import { render, staticRenderFns } from "./Jytp.vue?vue&type=template&id=bc0ef0be&scoped=true"
import script from "./Jytp.vue?vue&type=script&lang=js"
export * from "./Jytp.vue?vue&type=script&lang=js"
import style0 from "./Jytp.vue?vue&type=style&index=0&id=bc0ef0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0ef0be",
  null
  
)

export default component.exports